import { invalidParam, ValidationError } from 'common/errors';
import { pushUctpUnbind } from 'common/gamp';
import { markEnd, markStart } from 'common/instrumentation';
// eslint-disable-next-line import/no-restricted-paths
import orchUnBindAppInstance from 'orch-communicator/external/unbind-app-instance';
import {
  UnbindAppInstanceData,
  UnbindAppInstanceResponse
} from 'types/vsb-sdk/unbind-app-instance';
// eslint-disable-next-line import/no-restricted-paths
import { UnbindAppInstanceDataModel } from 'vsb-sdk/schemas/unbind-app-instance';

function validate(rawData: unknown): UnbindAppInstanceData {
  const result = UnbindAppInstanceDataModel.safeParse(rawData);

  if (!result.success) {
    throw invalidParam(result.error.issues);
  }

  return result.data;
}

export default async function unbindAppInstance(
  rawData: unknown
): Promise<UnbindAppInstanceResponse | ValidationError> {
  /* START GENAI@GHCOPILOT */
  markStart('vsb_merchant_pov_unbind');
  //START GENAI@GHCOPILOT
  try {
    validate(rawData);
  } catch (err: Error | unknown) {
    pushUctpUnbind(err instanceof Error ? err.message : 'Invalid rawData');
    return err as ValidationError;
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  const response = await orchUnBindAppInstance();

  if ('error' in response) {
    markEnd('vsb_merchant_pov_unbind', { doFlush: true, failure: true });
    pushUctpUnbind(response.error.message);
    return response as UnbindAppInstanceResponse | ValidationError;
  }

  markEnd('vsb_merchant_pov_unbind', { doFlush: true });
  pushUctpUnbind('');
  /* START GENAI@GHCOPILOT */
  return {};
}
//END GENAI@GHCOPILOT
